module.exports = "<p>\n  log-automacao works!\n</p>\n"